import { VStack, IconStatusNew, Box, HStack, Stack } from '@genial/components';
import { Utils } from '@genial/utils';
import React from 'react';

import {
  TableContentItemColumn,
  TableContentItemText,
} from '../../../../../../../../components/TableContent';
import { getFixedFeeColumnFlex } from '../../constants';

import { FixedFeeTermDetailsProps } from '.';

export const FixedFeeTermDetailsDesktop: React.FC<FixedFeeTermDetailsProps> = ({
  fixedFeeTerm,
  fixedFeeTermDetailed,
}) => {
  return (
    <VStack space="stack.xxxs" w="full" pt="stack.xxxs">
      <Box
        h="1px"
        bg={Utils.ColorToken.WithOpacity('brand.primary.principal', 'opacity.semitransparent')}
      />
      <HStack space={0} flex={1}>
        <TableContentItemColumn
          space="stack.quarck"
          flex={getFixedFeeColumnFlex(0) + getFixedFeeColumnFlex(1)}>
          <TableContentItemText color="neutral.medium" fontSize="xs">
            Última atualização do canal
          </TableContentItemText>
          <IconStatusNew
            color={fixedFeeTermDetailed.statusColor}
            icon={fixedFeeTermDetailed.statusIcon}
            status={fixedFeeTermDetailed.statusText}
          />
        </TableContentItemColumn>
        <TableContentItemColumn space="stack.quarck" flex={getFixedFeeColumnFlex(2)}>
          <TableContentItemText color="neutral.medium" fontSize="xs">
            Atualizado em
          </TableContentItemText>
          <TableContentItemText>{fixedFeeTermDetailed.updatedDateNormalized}</TableContentItemText>
        </TableContentItemColumn>
        <TableContentItemColumn space="stack.quarck" flex={getFixedFeeColumnFlex(3)}>
          <TableContentItemText color="neutral.medium" fontSize="xs">
            Evento
          </TableContentItemText>
          <TableContentItemText>{fixedFeeTerm.eventType}</TableContentItemText>
        </TableContentItemColumn>
        <Stack flex={getFixedFeeColumnFlex(4)} />
        <Stack flex={getFixedFeeColumnFlex(5)} />
        <Stack flex={getFixedFeeColumnFlex(6)} />
        <Stack flex={getFixedFeeColumnFlex(7)} />
      </HStack>
    </VStack>
  );
};
